import { type SVGProps } from "react";

export const MailInboxIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    {...props}>
    <path
      d="M6 3C4.34315 3 3 4.34315 3 6V14C3 15.6569 4.34315 17 6 17H14C15.6569 17 17 15.6569 17 14V6C17 4.34315 15.6569 3 14 3H6ZM16 10H12.5C12.2239 10 12 10.223 12 10.4991L11.9997 10.5114C11.9993 10.5238 11.9983 10.5443 11.9964 10.5718C11.9925 10.6269 11.9843 10.7088 11.9677 10.8084C11.9341 11.0101 11.8679 11.2713 11.7403 11.5264C11.6137 11.7796 11.4317 12.0176 11.168 12.1933C10.9074 12.3671 10.5375 12.5 10 12.5C9.46249 12.5 9.0926 12.3671 8.83204 12.1933C8.56834 12.0176 8.38631 11.7796 8.25971 11.5264C8.13214 11.2713 8.06586 11.0101 8.03226 10.8084C8.01565 10.7088 8.00755 10.6269 8.00361 10.5718C8.00165 10.5443 8.00075 10.5238 8.00033 10.5114L8 10.4994C7.99966 10.2235 7.77594 10 7.5 10H4V6C4 4.89543 4.89543 4 6 4H14C15.1046 4 16 4.89543 16 6V10ZM4 11H7.0505C7.09652 11.2643 7.18655 11.6161 7.36529 11.9736C7.55119 12.3454 7.83791 12.7324 8.27734 13.0254C8.7199 13.3204 9.28751 13.5 10 13.5C10.7125 13.5 11.2801 13.3204 11.7227 13.0254C12.1621 12.7324 12.4488 12.3454 12.6347 11.9736C12.8134 11.6161 12.9035 11.2643 12.9495 11H16V14C16 15.1046 15.1046 16 14 16H6C4.89543 16 4 15.1046 4 14V11Z"
      fill="currentColor"
    />
  </svg>
);

